"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFORDABLE_ANNUAL_INCOME_FIELD = exports.AFFORDABLE_MONTHLY_INCOME_FIELD = exports.AFFORDABLE_SEMI_MONTHLY_INCOME_FIELD = exports.AFFORDABLE_BI_WEEKLY_INCOME_FIELD = exports.AFFORDABLE_WEEKLY_INCOME_FIELD = exports.AFFORDABLE_HOURLY_INCOME_FIELD = exports.getAffordableIncomeFields = void 0;
exports.createPeriodicIncomeField = createPeriodicIncomeField;
var entities_1 = require("@common/entities");
var COMMON_ADDRESS_FIELDS_1 = require("../COMMON_ADDRESS_FIELDS");
var constants_1 = require("../../constants");
var getAffordableIncomeFields = function (type) {
    switch (type) {
        case entities_1.IncomeTypes.ChildSupport:
        case entities_1.IncomeTypes.FinancialAid:
        case entities_1.IncomeTypes.GeneralAssistance:
        case entities_1.IncomeTypes.IndianTrust:
        case entities_1.IncomeTypes.OtherNonWageSource:
        case entities_1.IncomeTypes.Pensions:
        case entities_1.IncomeTypes.SupplementalSecurityIncome:
        case entities_1.IncomeTypes.TemporaryAssistanceForNeedyFamilies:
        case entities_1.IncomeTypes.Unemployment:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Dropdown,
                    enabled: true,
                    label: 'Frequency of Other Income',
                    name: entities_1.IncomeFields.frequencyOfOtherIncome.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Dropdown,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Income Source',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 4,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 5,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 6,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 7,
                    type: entities_1.FieldType.Email,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(8), true), [
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: entities_1.IncomeFields.dateStarted.label,
                    name: entities_1.IncomeFields.dateStarted.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: entities_1.IncomeFields.dateEnded.label,
                    name: entities_1.IncomeFields.dateEnded.name,
                    required: true,
                    sequence: 16,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 17,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.MilitaryPay:
        case entities_1.IncomeTypes.FederalWage:
        case entities_1.IncomeTypes.BusinessOrRentalIncome:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Dropdown,
                    enabled: true,
                    label: 'Frequency of Other Income',
                    name: entities_1.IncomeFields.frequencyOfOtherIncome.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Dropdown,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Income Source',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: 'Start Date for this Employer',
                    name: entities_1.IncomeFields.dateStarted.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Job Title',
                    name: entities_1.IncomeFields.positionOrTitle.name,
                    required: true,
                    sequence: 4,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description of Job Duties',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 5,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Supervisor Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 6,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 7,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 8,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Supervisor Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 9,
                    type: entities_1.FieldType.Email,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(10), true), [
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 17,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.SocialSecurity:
            return [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Social Security Claim Number',
                    name: entities_1.IncomeFields.socialSecurityClaimNumber.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.File,
                },
            ];
        case entities_1.IncomeTypes.NonFederalWages:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Radio,
                    enabled: true,
                    label: 'Do you receive overtime pay for this income type?',
                    name: entities_1.IncomeFields.memberReceivesOvertimePay.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Radio,
                    options: constants_1.YES_NO_OPTIONS,
                },
                {
                    customType: entities_1.FieldType.Radio,
                    enabled: true,
                    label: 'Do you receive bonuses for this income type?',
                    name: entities_1.IncomeFields.memberReceivesBonuses.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Radio,
                    options: constants_1.YES_NO_OPTIONS,
                },
                {
                    customType: entities_1.FieldType.Radio,
                    enabled: true,
                    label: 'Do you receive tips for this income type?',
                    name: entities_1.IncomeFields.memberReceivesTips.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.Radio,
                    options: constants_1.YES_NO_OPTIONS,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Income Source',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 4,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: 'Start Date for this Employer',
                    name: entities_1.IncomeFields.dateStarted.name,
                    required: true,
                    sequence: 5,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Job Title',
                    name: entities_1.IncomeFields.positionOrTitle.name,
                    required: true,
                    sequence: 6,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 7,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Supervisor Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 8,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 9,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Supervisor Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.Email,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(12), true), [
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 20,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.PublicAssistance:
        case entities_1.IncomeTypes.RetirementPlanPayments:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Dropdown,
                    enabled: true,
                    label: 'Frequency of Other Income',
                    name: entities_1.IncomeFields.frequencyOfOtherIncome.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Dropdown,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Income Source',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 4,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 5,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 6,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 7,
                    type: entities_1.FieldType.Email,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(8), true), [
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.File,
                },
            ], false);
        default:
            return [];
    }
};
exports.getAffordableIncomeFields = getAffordableIncomeFields;
/**
 * Creates a periodic income field configuration
 */
function createPeriodicIncomeField(label, includeHoursAndWeeks) {
    if (includeHoursAndWeeks === void 0) { includeHoursAndWeeks = false; }
    var baseField = {
        customType: entities_1.FieldType.Amount,
        enabled: true,
        label: label,
        name: entities_1.IncomeFields.amount.name,
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Amount,
    };
    if (!includeHoursAndWeeks) {
        return [baseField];
    }
    var hoursField = {
        customType: entities_1.FieldType.Number,
        enabled: true,
        label: 'Hours Per Week',
        name: entities_1.IncomeFields.hourPerWeek.name,
        required: true,
        sequence: 2,
        type: entities_1.FieldType.Number,
    };
    var weeksField = {
        customType: entities_1.FieldType.Number,
        enabled: true,
        label: 'Weeks Per Year',
        name: entities_1.IncomeFields.weekPerYear.name,
        required: true,
        sequence: 3,
        type: entities_1.FieldType.Number,
    };
    return [baseField, hoursField, weeksField];
}
/**
 * Hourly income field configuration
 */
exports.AFFORDABLE_HOURLY_INCOME_FIELD = createPeriodicIncomeField('Hourly Wage', true);
/**
 * Weekly income field configuration
 */
exports.AFFORDABLE_WEEKLY_INCOME_FIELD = createPeriodicIncomeField('Weekly Salary');
/**
 * Bi-weekly income field configuration
 */
exports.AFFORDABLE_BI_WEEKLY_INCOME_FIELD = createPeriodicIncomeField('Bi-weekly Salary');
/**
 * Semi-monthly income field configuration
 */
exports.AFFORDABLE_SEMI_MONTHLY_INCOME_FIELD = createPeriodicIncomeField('Semi-monthly Salary');
/**
 * Monthly income field configuration
 */
exports.AFFORDABLE_MONTHLY_INCOME_FIELD = createPeriodicIncomeField('Monthly Salary');
/**
 * Annual income field configuration
 */
exports.AFFORDABLE_ANNUAL_INCOME_FIELD = createPeriodicIncomeField('Annual Salary');
